import React from "react";
import { motion } from "framer-motion";
import { Loader } from "lucide-react";
import "./Dashboard.css";

/**
 * ProcessingIndicator - Displays a loading indicator with message
 * @param {boolean} isLoading - Whether to show the indicator
 * @param {string} message - Optional custom message (default: "Processing... please allow up to one minute")
 */
export default function ProcessingIndicator({ isLoading, message = "Processing... please allow up to one minute" }) {
  if (!isLoading) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="processing-indicator"
    >
      <Loader size={16} className="spinning" />
      <span>{message}</span>
    </motion.div>
  );
}

